var exports = {
  "nM": "ComparisonCheckRow.module__row___VjJxUW",
  "N4": "ComparisonCheckRow.module__feature___VjJxUW",
  "oo": "ComparisonCheckRow.module__featureText___VjJxUW",
  "a7": "ComparisonCheckRow.module__valuesContainer___VjJxUW",
  "S7": "ComparisonCheckRow.module__valueCell___VjJxUW",
  "oE": "ComparisonCheckRow.module__checkIcon___VjJxUW",
  "T7": "ComparisonCheckRow.module__dash___VjJxUW",
};

module.exports = exports;
